export const searchJobHitZeroWhenPostedDateHiddenVar =
  '--search-job-hit-zero-when-posted-date-hidden';

export const searchJobHitOneWhenEarlyApplicantVisibleVar =
  '--search-job-hit-one-when-early-applicant-visible';

export const searchJobHitTransparentWhenBorderHiddenVar =
  '--search-job-hit-transparent-when-border-hidden';
